import CajaModule from '../../../components/ui/Cajero/CajaComponents/CajaModule';

const CajaUI = () => {
  return (
    <div className="min-h-screen bg-[var(--surface-page)]">
      <div className="mx-auto max-w-7xl px-4 py-6 md:px-6">
        <CajaModule />
      </div>
    </div>
  );
};

export default CajaUI;
